import { createAction, props } from '@ngrx/store';
import type { PlatformDashboardData } from './platform-dashboard.models';

export const PlatformDashboardLoadRequest = createAction('[Platform Dashboard] Load Request');
export const PlatformDashboardLoadSuccess = createAction(
  '[Platform Dashboard] Load Success',
  props<{ data: PlatformDashboardData }>(),
);
export const PlatformDashboardLoadFailure = createAction(
  '[Platform Dashboard] Load Failure',
  props<{ error: string }>(),
);
